import styled, {css} from "styled-components";

export const StyledMenuManagementAccor = styled.div`
    box-shadow: 0px 1px 16px 0px #00000014;
    background: var(--white);
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 15px;
    .head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 15px;
        border-bottom: 1px solid ${({$active}) => ($active ? "#e1e4e8" : "transparent")};
        transition: 1s all ease-in-out;
        cursor: pointer;

        @media (min-width: 768px) {
            padding: 10px 21px;
        }

        .main-title {
            display: flex;
            justify-content: center;
            align-items: center;
            @media (min-width: 575px) {
                gap: 20px;
            }
            button {
                width: 190px;
                border: none;
                background-color: transparent;
                color: var(--black);
            }
            .title {
                font-size: 18px;
                font-weight: 400;
                line-height: 22px;
                text-align: left;
                color: #313131;
            }
        }
        .arrow {
            transition: 0.3s all ease-in-out;
            color: #313131;
            transform: scale(-1);
            cursor: pointer;
            transition: 0.5s all ease-in-out;
        }
        .delete-btn {
            gap: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
        }
        .open {
            transform: scale(1);
        }
    }
`;

export const CategoryBody = styled.div`
    ${({$choice, $category}) =>
        $choice || $category
            ? css`
                  max-height: max-content;
              `
            : css`
                  max-height: ${({$active}) => ($active ? "5000px" : "0px")};
              `};
    transition: 1s all ease-in-out;
    .fake-table-header {
        display: none;
        padding: 16px 22px;
        color: #777777;
        gap: 2px;
        @media (min-width: 992px) {
            display: grid;
            gap: 20px;
            grid-template-columns: 0.2fr 1fr 1fr 1fr 1fr 0.5fr 0.5fr 0.5fr 0.5fr;
        }
        @media (min-width: 1326px) {
            grid-template-columns: 0.2fr 1.5fr 1fr 1fr 1fr 0.5fr 0.5fr 0.5fr 0.5fr;
        }
        span {
            white-space: nowrap;
            user-select: none;
        }
    }
    .fake-table-header-choice {
        display: none;
        padding: 16px 22px;
        color: #777777;
        gap: 2px;
        @media (min-width: 992px) {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
        }
        @media (min-width: 1326px) {
            grid-template-columns: 1fr 1fr 1fr;
        }
        span {
            white-space: nowrap;
            user-select: none;
        }
    }
`;

export const FakeTabelBody = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    padding: 16px 22px;
    align-items: center;
    gap: 4px;
    border-bottom: 1px solid #e1e4e8;
    position: relative;
    @media (min-width: 992px) {
        display: grid;
        grid-template-columns: 0.2fr 1fr 1fr 1fr 1fr 0.5fr 0.5fr 0.5fr 0.5fr;
        gap: 20px;
    }
    @media (min-width: 1326px) {
        grid-template-columns: 0.2fr 1.5fr 1fr 1fr 1fr 0.5fr 0.5fr 0.5fr 0.5fr;
    }
    &:last-child {
        border-bottom: none;
    }

    ${({$category}) =>
        $category &&
        css`
            display: grid;
            grid-template-columns: 1fr;
            padding: 16px 22px;
            align-items: center;
            gap: 10px;
            border: none;
            margin-bottom: 15px;
            border-radius: 10px;
            background: #f0f2f3;
            z-index: 999;

            @media (min-width: 1326px) {
                /* grid-template-columns: 0fr 0.45fr 1fr; */
                grid-template-columns: 0fr 0.388fr 1fr;
            }
        `}

    ${({$choice}) =>
        $choice &&
        css`
            display: grid;
            grid-template-columns: 1fr;
            padding: 16px 22px;
            align-items: center;
            gap: 10px;
            border: none;
            box-shadow: 0px 1px 16px 0px #00000014;
            margin-bottom: 15px;
            border-radius: 10px;
            background: var(--white);
            @media (min-width: 992px) {
                display: grid;
                grid-template-columns: 1fr 1fr 1fr 0.3fr;
                gap: 20px;
            }
            @media (min-width: 1326px) {
                grid-template-columns: 1fr 1fr 1fr 0.3fr;
            }
            .choice-name {
                display: flex;
                align-items: center;
                gap: 10px;
                .title {
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 400;
                    text-align: left;
                    display: block;
                    margin-bottom: 4px;
                    color: var(--text-color);
                    @media (min-width: 992px) {
                        font-size: 20px;
                        line-height: 24px;
                    }
                }
                .text {
                    font-size: 14px;
                    font-weight: 300;
                    line-height: 18px;
                    text-align: left;
                    color: #777777;
                }
            }
            .choices {
                font-size: 14px;
                line-height: 18px;
                font-weight: 400;
                color: var(--text-color);
                text-align: center;
                @media (min-width: 992px) {
                    text-align: left;
                    font-size: 18px;
                    line-height: 22px;
                }
            }
        `}
.CategroyName {
        color: #313131;
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        text-align: left;
        display: flex;
        align-items: center;
        gap: 10px;
        .itemsName {
            width: 100%;
            max-width: 180px;
        }
        img {
            border-radius: 5px;
        }
    }
    .fake-td {
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
    }
    .success {
        color: var(--success);
    }
    .danger {
        color: var(--danger);
    }
    .pricing {
        display: flex;
        align-items: flex-end;
        gap: 5px;
    }
    .old-price {
        font-size: 12px;
        line-height: 16px;
        margin-bottom: 0;
        text-decoration: line-through;
    }
    .action-btn {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .edit,
    .delete {
        width: 26px;
        height: 26px;
        border-radius: 8px;
        background: #ffdfdf;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .edit {
        background: #fde5d4;
    }
    .delete {
        background-color: #ff2d2d26;
    }
    .fake-table-resp {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .thead-row {
            color: #777777;
            font-size: 14px;
            line-height: 18px;
            @media (min-width: 992px) {
                display: none;
            }
        }
        @media (min-width: 992px) {
            width: auto;
        }
    }
`;

export const FakeGroupTableBody = styled.div`
    display: grid;
    grid-template-columns: 0.2fr 1.5fr 1fr 1fr;

    .fake-table-resp {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .row-heading {
        display: block;
    }
`;
export const TableRowsWrapper = styled.div``;

export const MenuManageMentHeader = styled.div`
    .heading {
        margin-bottom: 30px;
        font-size: 16px;
        line-height: 20px;
        font-weight: 300;
        color: var(--gray);
        @media (min-width: 768px) {
            font-size: 18px;
            line-height: 22px;
        }
    }
    .tabs {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-direction: column;
        gap: 20px;
        margin-bottom: 15px;

        @media (min-width: 400px) {
            border-bottom: 1px solid #f1f1f1;
            align-items: baseline;
        }

        @media (min-width: 992px) {
            flex-direction: row;
            margin-bottom: 30px;
        }

        .tab {
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            gap: 16px;
            max-width: 400px;

            @media (min-width: 575px) {
                gap: 20px;
            }
        }
        .tab strong {
            cursor: pointer;
            color: var(--gray);
            border-bottom: 2px solid transparent;
            padding-bottom: 11px;
            transition: color 0.3s, border-color 0.3s;
        }
        .tab strong.active {
            color: ${({theme}) => theme?.light?.primary};
            border-bottom: 2px solid ${({theme}) => theme?.light?.primary};
            padding-bottom: 11px;
        }
        .copy {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            gap: 10px;
            width: 100%;
            padding: 0 0 15px;

            @media (min-width: 575px) {
                flex-direction: row;
            }

            @media (min-width: 992px) {
                width: auto;
                padding: 0;
            }

            button {
                background-color: transparent;
                border: 1px solid var(--black);
                color: var(--black);
                padding: 9px 20px;
                width: 100%;

                @media (min-width: 575px) {
                    width: 50%;
                    min-width: 50%;
                }
                @media (min-width: 992px) {
                    margin: 0;
                    width: auto;
                }
            }

            .select-holder {
                width: 100%;

                @media (min-width: 575px) {
                    width: 50%;
                }
                @media (min-width: 992px) {
                    width: auto;
                }
                .react-select__control {
                    height: 40px;
                }
            }
        }
    }
`;
export const AddMenuStyles = styled.div`
    .title {
        display: block;
        margin-bottom: 20px;
        font-size: 20px;
        font-weight: 400;
        line-height: 24px;
        text-align: left;
    }
    .info {
        display: flex;
        align-items: center;
        gap: 10px;
        /* background: #feecdf; */
        background: ${({theme}) => theme?.light?.primary50};
        padding: 20px 15px;
        font-size: 14px;
        font-weight: 300;
        line-height: 17px;
        text-align: left;
        color: #313131;
        border-radius: 20px;
        margin-bottom: 30px;
        span {
            svg {
                width: 20px;
                height: 20px;
                color: ${({theme}) => theme?.light?.primary};
            }
        }
    }

    .choice-example {
        display: block;
        margin: 0 0 20px;
    }
    .sub-choice-btn {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 10px;
        font-size: 14px;
        color: var(--primary);
        cursor: pointer;
    }
    .delete-btn {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 10px;
    }

    .choice-detail-title {
        margin: 0 0 10px;
    }

    .choice-detail {
        margin: 0 0 20px;
    }
    .choice-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 0 20px;

        button {
            padding: 5px 15px;
        }
    }

    hr {
        border: 1px solid #ececec;
        margin-bottom: 20px;
    }
    .combine-fields {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        column-gap: 5px;
        @media (min-width: 575px) {
            grid-template-columns: repeat(2, 1fr);
            /* grid-template-columns: 1fr 1fr; */
            column-gap: 20px;
        }
    }

    .select-all-container {
        display: flex;
        justify-content: flex-start;
        margin: 0 0 15px;

        .select-all {
            display: flex;
            align-items: center;
            gap: 5px;
            padding: 10px 15px;
            background: #f8f9fa;
            border: 1px solid #e9ecef;
            border-radius: 60px;
            cursor: pointer;
            font-weight: 500;
            transition: all 0.2s ease;

            &:hover {
                background: #e9ecef;
            }

            &.active {
                background: ${({theme}) => theme?.light?.primary}15;
                border: 1px solid ${({theme}) => theme?.light?.primary};

                .icon {
                    display: block;
                }
            }

            .icon {
                display: none;
                color: ${({theme}) => theme?.light?.primary};
            }
        }
    }

    .all-day-container {
        display: flex;
        justify-content: flex-start;
        margin: 0 0 15px;

        .all-day-toggle {
            display: flex;
            align-items: center;
            gap: 5px;
            padding: 10px 15px;
            background: #f8f9fa;
            border: 1px solid #e9ecef;
            border-radius: 60px;
            cursor: pointer;
            font-weight: 500;
            transition: all 0.2s ease;

            &:hover {
                background: #e9ecef;
            }

            &.active {
                background: ${({theme}) => theme?.light?.primary}15;
                border: 1px solid ${({theme}) => theme?.light?.primary};

                .icon {
                    display: block;
                }
            }

            .icon {
                display: none;
                color: ${({theme}) => theme?.light?.primary};
            }
        }
    }

    .week {
        display: flex;
        gap: 14px;
        margin: 0 0 20px;
        overflow-x: auto;
        padding-bottom: 10px;
        .day {
            display: flex;
            align-items: center;
            gap: 5px;
            padding: 10px 15px;
            border: 1px solid var(--gray-50);
            border-radius: 60px;
            cursor: pointer;

            &.active {
                border: 1px solid ${({theme}) => theme?.light?.primary};
                .icon {
                    display: block;
                }
            }

            .icon {
                display: none;
            }
        }
    }

    .date-picker {
        display: flex;
        gap: 10px;
        margin: 0 0 40px;

        .react-datepicker-wrapper {
            width: 100%;
        }
        .react-datepicker-popper {
            width: 200px;
            .react-datepicker {
                width: 100%;
            }
            .react-datepicker__time-container {
                width: 100%;
                .react-datepicker__time-box {
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }

    .btn-holder {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        gap: 20px;
        @media (min-width: 575px) {
            flex-direction: row;
            gap: 7px;
        }
        @media (min-width: 870px) {
            gap: 20px;
        }
        .btn {
            button {
                width: 300px !important;
                @media (min-width: 575px) {
                    width: 165px !important;
                }
                @media (min-width: 870px) {
                    width: 250px !important;
                }
            }
        }
    }
    .dropdownWrap {
        position: relative;
        width: 100%;
        max-width: 160px;
        background-color: #289a001a;
        text-align: center;
        padding: 8px 10px;
        border-radius: 25px;
        &.available {
            background-color: #289a001a;
        }
        &.unavailable {
            background-color: #feecdf;
        }
        .modal-dropdown {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 5px;
            margin: 0 auto;
            .dot {
                width: 8px;
                height: 8px;
                background-color: green;
                border-radius: 100%;
                flex-shrink: 0;
                @media (min-width: 992px) {
                    width: 12px;
                    height: 12px;
                }
            }
            .available {
                background: green;
            }
            .unavailable {
                background: red;
            }
            .dropdown {
                display: flex;
                justify-content: space-between;
                gap: 5px;
                align-items: center;
                position: relative;
                font-size: 16px;
                line-height: 20px;
                font-weight: 300;
                color: green;
                cursor: pointer;
                position: relative;
                @media (min-width: 992px) {
                    font-size: 18px;
                    line-height: 22px;
                }
                .available {
                    color: green;
                    background: transparent;
                }
                .unavailable {
                    color: red;
                    background: transparent;
                }
                p {
                    margin: 0;
                }
            }
            .styled-select {
                position: absolute;
                top: 35px;
                left: 0;
                width: 140px;
                background: var(--white);
                border: 1px solid var(--gray-tune, #dfdfdf);
                border-radius: 8px;
                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                text-align: left;
                font-size: 16px;
                line-height: 22px;
                font-weight: 300;
                padding: 10px 0;
                z-index: 1;
                .available {
                    color: green;
                    background: transparent;
                }
                .unavailable {
                    color: red;
                    background: transparent;
                }
                li {
                    padding: 5px 15px;
                    cursor: pointer;
                    color: #313131;
                    &:hover {
                        background: var(--primary);
                        color: var(--white);
                    }
                }
            }
        }
    }
`;
